import {PureComponent} from 'react';
import ReactDOM from 'react-dom';

// TODO: This is temporary, remove this
const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

interface Props {
    /** Callback fired when portal content has rendered. */
    onRendered?: () => void;
}

/**
 * Portal component provides a way to render components outside of the DOM
 * hierarchy of the parent component. This is useful for creating floating
 * temporary panels such as menus, dialogs, dropdowns, sidepops, etc.
 */
export class Portal extends PureComponent<Props> {
    public componentDidMount() {
        if (this.props.onRendered) {
            this.props.onRendered();
        }
    }

    public render() {
        // TODO: Temp fix for SSR
        if (canUseDOM) {
            return ReactDOM.createPortal(this.props.children, document.body);
        }

        return null;
    }
}

// TODO: tests for default props
// TODO: test props: onRendered callback
